/* 

*/

import Servicos from "pages/Servicos";

export default function ServicosPage() {
  return <Servicos />;
}
